/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Layout, StaticSEO } from '@core';
import { BlogPage } from '@composite';

const Page = () => (
  <Layout invertedHeader>
    <StaticSEO pageId='blog' />
    <BlogPage />
  </Layout>
);

export default Page;
